export default function AdminAppLayout({ children }) {
  return (
    <main className="admin-app">
      <div className="admin-app-inner">{children}</div>
    </main>
  );
}
